<template>
  <div class="box7-page">
    <pageTitle 
      title="课程内容高度凝练  快速讲透账号运营全体系" 
      tit="拒绝冗余、低效，时间也是成本！"
      titleColor="#000"
      titColor="#333"
    />
    <div class="page-content common-animation">
      <div class="left-cont">
        <ul>
          <li 
            v-for="(item, index) in list" 
            :key="item.name" 
            :class="{active: index === currIndex}"
            @mouseenter="currIndex = index"
          >
            <span :class="`type${item.type}`">{{ arr[item.type - 1] }}</span>
            <p>{{ item.name }}</p>
          </li>
        </ul>
      </div>
      <div class="right-cont">
        <div class="more-btn" @click="childMethod">了解更详细内容>></div>
        <div class="right-cont-mask">
          <div class="cont-box">
            <div class="cont-title">
              <div class="img-mask">
                <img src="../../../assets/topic-page/newMedia2/box7/icon-01.png" alt="">
              </div>
              <span>主讲内容</span>
            </div>
            <ul class="info-list">
              <li v-for="item in list[currIndex].info1">{{ item }}</li>
            </ul>
          </div>
          <div class="cont-box">
            <div class="cont-title">
              <div class="img-mask">
                <img src="../../../assets/topic-page/newMedia2/box7/icon-02.png" alt="">
              </div>
              <span>学后收获</span>
            </div>
            <ul class="info-list">
              <li v-for="item in list[currIndex].info2">{{ item }}</li>
            </ul>
          </div>
          <div class="cont-box">
            <div class="cont-title">
              <div class="img-mask">
                <img src="../../../assets/topic-page/newMedia2/box7/icon-03.png" alt="">
              </div>
              <span>可解决的现实问题</span>
            </div>
            <ul class="info-list">
              <li v-for="item in list[currIndex].info3">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="btn" @click="childMethod">申请免费试听</div>
  </div>
</template>

<script>
  import pageTitle from '../../../components/common/pageTitle.vue';
  export default {
    name: '',
    components:{
      pageTitle
    },
    data() {
      return {
        arr: ['推荐流量', '搜索流量', '付费流量'],
        currIndex: 0,
        list: [
          {
            name: '人设型粉丝经济的价值',
            type: 1,
            info1: [
              '1.什么是人设？',
              '2.形成有效人设的核心方法？',
              '3.成功人设类视频带货账号案例',
              '4.爱达模型阐述粉丝经济产生的底层逻辑'
            ],
            info2: [
              '了解打造人设，最终形成IP，实现变现的最基本底层逻辑-正向人设是产生粉丝经济的基础。'
            ],
            info3: [
              '学员初步了解人设在带货类账号中的作用，能够根据自己的情况，罗列正向标签，按照课程内容进行组合展示。'
            ]
          },
          {
            name: '抖音平台核心规则',
            type: 1,
            info1: [
              '1.3+2算法机制',
              '2.平台的推荐原理-双向数据匹配',
              '3.作品的推荐流程',
              '4.影响推荐流量的核心因素',
              '5.内容质量影响因素及对应因素的具体参考标准',
              '6.账号权重影响因素及对应权重情况解读',
              '7.内容质量提升自检清单'
            ],
            info2: [
              '了解平台的推荐原理，清楚影响账号作品流量的核心因素有哪些，提升作品内容质量应该从哪些维度进行自检提升。'
            ],
            info3: [
              '清楚平台的推荐原理，了解自己行业对应内容质量好坏的参考标准；',
              '内容产出后清楚从哪些维度检查自己的内容质量是否合格。',
            ]
          },
          {
            name: '内容定位',
            type: 1,
            info1: [
              '1.平台最简单的逻辑',
              '2.数据分析表教你做账号的正确逻辑',
              '3.点面内容定位法',
              '4.不同赛道定位自己内容形式的方法案例',
              '5.差异化内容设计三部曲-文案内容差异化方法',
              '6.差异化内容设计三部曲-内容载体差异化方法',
              '7.差异化内容设计三部曲-设定差异的方法',
              '8.内容定位策划框架万能公式'
            ],
            info2: [
              '解决定位问题；',
              '解决没有内容可拍的问题；',
              '完成有差异化、有辨识度、容易让用户记住的内容定位。'
            ],
            info3: [
              '通过大量数据分析得出视频变现账号的内容应该如何设计；',
              '通过文案内容差异化、内容载体差异化、设定差异化，帮助完成账号的差异化定位；',
              '配合万能公式轻松落地实操。'
            ]
          },
          {
            name: '账号搭建',
            type: 1,
            info1: [
              '1.账号五件套的核心作用',
              '2.如何设计自带流量的名称',
              '3.如何设计自己的背景图可以提升关注数据',
              '4.如何设计自己的简介可以增强人设提升带货数据',
              '5.账号搭建自检表-确保不同视角都符合账号搭建要求'
            ],
            info2: [
              '掌握账号如何搭建。'
            ],
            info3: [
              '完成自己账号的设置；',
              '能给自己账号起一个自带流量的名称；',
              '能做符合账号调性、引导关注的背景头图；',
              '可以做提升信任感的、有明显人设特点的简介；',
              '可以使用自检表检查账号搭建是否合理。'
            ]
          },
          {
            name: '正确理解对标账号',
            type: 1,
            info1: [
              '1.对标账号真正的意义',
              '2.如何建立对标库',
              '3.主动和被动获取对标的方法'
            ],
            info2: [
              '能够独立搭建出对标账号库，辅助账号运营。'
            ],
            info3: [
              '帮助学员清楚长期对标和短期对标，从而解决账号运营的数据问题，独立搭建出对标库。'
            ]
          },
          {
            name: '精细化内容拆解-拉片',
            type: 1,
            info1: [
              '1.精细化内容拆解-拉片核心目的',
              '2.精细化内容拆解-拉片文案结构公式',
              '3.精细化内容拆解-拉片工具',
              '4.精细化内容拆解-拉片案例拆解'

            ],
            info2: [
              '掌握精细化分析案例的拉片方法。'
            ],
            info3: [
              '解决学员不清楚如何拍摄，无镜头可拍的问题。'
            ]
          },
          {
            name: '素材库搭建',
            type: 1,
            info1: [
              '1.素材库搭建的意义',
              '2.关键词索引法搭建素材库',
              '3.素材库搭建工具'
            ],
            info2: [
              '学会搭建素材库，后续能有源源不断的素材可以拍。'
            ],
            info3: [
              '素材库是账号运作很重要的一步，本节课程帮助学员彻底解决不会拓展素材、不会搭建素材库的问题。'
            ]
          },
          {
            name: '脚本结构详细公式',
            type: 1,
            info1: [
              '1.视频变现的4种分类',
              '2.带货视频6大爆火脚本结构详解',
              '3.带货视频6大爆火脚本案例分析',
              '4.专业测评类脚本结构公式',
              '5.人设种草类脚本结构公式',
              '6.直接推荐类脚本结构公式',
              '7.内容带货类脚本结构公式',
              '8.开箱展示类脚本结构公式',
              '9.剧情演绎类脚本结构公式'
            ],
            info2: [
              '掌握拍摄带货技能。'
            ],
            info3: [
              '本节课程将带货视频拆分总结了6大结构，每个结构总结了爆款的公式，学员可以直接套用。'
            ]
          },
          {
            name: '人设IP塑造和传播',
            type: 1,
            info1: [
              '1.平台4种超能变现的人设IP',
              '2.简单一步骤塑造差异化人设IP',
              '3.人设IP快速传播的一套实操方案'
            ],
            info2: [
              '完成账号差异化人设IP的策划。'
            ],
            info3: [
              '解决学员策划的人设形象比较普通，没有辨识度的问题。'
            ]
          },
          {
            name: '如何快速涨粉',
            type: 1,
            info1: [
              '1.连爆视频涨粉法',
              '2.借势涨粉法',
              '3.dou+引爆涨粉法',
              '4.野路子快速涨粉',
              '5.直播小套路涨粉',
              '6.账号千川涨粉法',
              '7.跨平台涨粉法'
            ],
            info2: [
              '快速涨到1000粉。'
            ],
            info3: [
              '根据课程中7种涨粉方法快速涨到1000粉。从而能够开通商品橱窗、团购达人、数据分析等功能，也有助于快速掌握涨粉方法，完成账号的冷启动。'
            ]
          },
          {
            name: '账号数据分析',
            type: 1,
            info1: [
              '1.看数据的六大端口',
              '2.五类数据全解析（视频、电商、账号、粉丝、直播数据）',
              '3.数据指标问题排查'
            ],
            info2: [
              '学会账号数据分析。'
            ],
            info3: [
              '根据课程中的方法找到五种类型的数据分析入口，了解每个数据指标的含义，并可以对每个指标问题进行排查。'
            ]
          },
          {
            name: '最精准流量',
            type: 2,
            info1: [
              '1.搜索流量关键词正确布局位置',
              '2.6类关键词布局技巧',
              '3.5个工具快速拓展关键词',
              '4.什么是热搜词',
              '5.什么是行业词',
              '6.什么是交易关联词',
              '7.什么是账号设定词',
              '8.什么是内容关联词',
              '9.什么是习惯信息词',
              '10.建立话题之布局关键词',
              '11.电商关键词布局案例',
              '12.看后搜布局意义',
              '13.如何获得看后搜4大展示链',
              '14.3个步骤用于种草型的后搜词'
            ],
            info2: [
              '让账号获得更多更精准的搜索流量。'
            ],
            info3: [
              '通过工具快速挖掘能变现的关键词，然后进行合理布局；',
              '解决好物带货类账号堆量的痛点。'
            ]
          },
          {
            name: '抖+投放',
            type: 3,
            info1: [
              '1.抖+批量投放如何使用',
              '2.新号没标签/推流少/数据差，如何通过抖+进行提升',
              '3.作品流量卡在几百几千，如何通过抖+破流量层级',
              '4.粉丝基数少如何通过抖+快速低价涨粉',
              '5.哪些作品可以用抖+加热，哪些投过的作品可以复投对应标准及复投方法',
              '6.哪些行业适合通过抖+留资获客，快速获取客户资源的投放方法',
              '7.抖+审核不过，以及跑不动的自检方法'
            ],
            info2: [
              '获得投放打标签、破流量层级、快速涨粉、加热上热门及获取客户资源的能力。'
            ],
            info3: [
              '解决账号标签不精准、流量卡在一个范围、不涨粉、不热门等问题。'
            ]
          },
          {
            name: '小店随心推',
            type: 3,
            info1: [
              '1.小店随心推投放判断盈亏的方法',
              '2.千粉无标签ROI跑不正，如何快速通过小店随心推测款跑ROI',
              '3.几千粉丝用户精准ROI跑不正，如何通过小店随心推快速测款跑ROI',
              '4.几千粉丝用户不精准ROI跑不正，如何用小店随心推快速测款跑ROI',
              '5.解决小店随心推开始ROI很高，后面ROI很低的方法',
              '6.多开的计划中有单个ROI高，计划后面如何做投放计划',
              '7.投放爆单后如何做小店随心推的复投计划',
              '8.自然流爆单后如何做小店随心推投放计划',
              '9.小店随心推审核不过/不跑量调整方法'
            ],
            info2: [
              '获得面对不同投放问题的对应解决投放技巧。'
            ],
            info3: [
              '掌握各个阶段投放问题的解决方法。'
            ]
          }
        ]
      }
    },
    methods:{
      childMethod() {
        this.$parent.itcastClick();
      }
    }
  }
</script>

<style lang="scss" scoped>
.box7-page{
  height: 820px;
  background-image: url(../../../assets/topic-page/newMedia2/box7/box7-bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 80px;
  box-sizing: border-box;
  .btn{
      width: 207px;
      height: 56px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 56px;
      border-radius: 28px;
      font-weight: bold;
      box-sizing: border-box;
      box-shadow: 0 8px 7px #e2b8db;
      background: url("../../../assets/topic-page/newMedia2/btnbg1.png") no-repeat;
      cursor: pointer;
      margin: 40px auto 0;
      padding-right: 20px;
      &:hover{
        box-shadow: none;
      }
    }
  .page-content{
    width: 1200px;
    margin: 40px auto 0;
    display: flex;
    .left-cont{
      width: 360px;
      height: 448px;
      background-image: linear-gradient(0deg, 
        #fff0f5 0%, 
        #ffe5ee 100%);
      box-shadow: 0px 10px 20px 0px 
        #f6edf0;
      border-radius: 20px;
      border: solid 1px #ffccdd;
      box-sizing: border-box;
      padding: 20px 6px 20px 20px;
      ul{
        padding-right: 14px;
        overflow-y: auto;
        height: 408px;
        overflow-x: hidden;
        &::-webkit-scrollbar {
          width: 3px;
          background-color: transparent;
        }
        /*定义滑块 内阴影+圆角*/
        &::-webkit-scrollbar-thumb {
          width: 3px;
          height: 200px;
          background-color: #24ba8b;
          border-radius: 2px;
          opacity: 0.4;
        }
        li{
          width: 320px;
          height: 48px;
          background-color: #fff5f8;
          border-radius: 10px;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          padding: 11px 10px;
          box-sizing: border-box;
          cursor: pointer;
          &:last-child{
            margin: 0;
          }
          span{
            min-width: 80px;
            width: 80px;
            height: 26px;
            border-radius: 5px;
            margin-right: 11px;
            line-height: 26px;
            font-family: PingFang-SC-Regular;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            text-align: center;
            box-sizing: border-box;
            &.type1{
              background-color: #f1ebff;
              color: #7733ff;
            }
            &.type2{
              background-color: #ffebff;
              color: #ff33ff;
            }
            &.type3{
              background-color: #ffebf1;
              color: #ff3377;
            }
          }
          p{
            flex: 1;
            font-family: PingFang-SC-Regular;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 1px;
            color: #33141f;
            text-overflow:ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          &.active,
          &:hover{
            background-color: #ff7faa;
            span{
              border: solid 1px #ffffff;
              background: transparent;
              color: #fff;
              box-sizing: border-box;
              line-height: 25px;
            }
            p{
              font-family: PingFang-SC-Heavy;
              font-weight: 600;
              color: #fff;
            }
          }
        }
      }
    }
    .right-cont{
      width: 840px;
      height: 448px;
      padding: 37px 10px 37px 28px;
      background-color: #ffffff;
      box-shadow: 0px 10px 20px 0px 
      #f6edf0;
      border-radius: 20px;
      box-sizing: border-box;
      position: relative;
      .more-btn{
        cursor: pointer;
        position: absolute;
        top: 33px;
        right: 35px;
        width: 140px;
        height: 30px;
        box-shadow: 0px 0px 5px 0px 
          #eeebf5;
        border-radius: 8px;
        border: solid 1px #ff3377;
        text-align: center;
        line-height: 30px;
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ff3377;
        &:hover{
          background-color: #ff3377;
          color: #fff;
        }
      }
      .right-cont-mask{
        height: 374px;
        overflow: hidden;
        overflow-y: auto;
        padding-right: 10px;
        &::-webkit-scrollbar {
          width: 3px;
          background-color: transparent;
        }
        /*定义滑块 内阴影+圆角*/
        &::-webkit-scrollbar-thumb {
          width: 3px;
          height: 200px;
          background-color: #24ba8b;
          border-radius: 2px;
          opacity: 0.4;
        }

        .cont-box{
          .cont-title{
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .img-mask{
              width: 17px;
              height: 17px;
              text-align: center;
              margin-right: 7px;
              img{
                height: 17px;
              }
            }
            span{
              font-family: PingFang-SC-Bold;
              font-size: 19px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 1px;
              color: #333333;
            }
          }
          ul{
            margin-bottom: 26px;
            padding-left: 24px;
            li{
              font-family: PingFang-SC-Regular;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 30px;
              letter-spacing: 0px;
              color: #253326;
            }
          }
          &:last-child{
            ul{
              margin: 0;
            }
          }
        }
      }
    }
  }
}
</style>